import { Col } from "react-bootstrap";
import React from "react";

export const ProjectCard = ({ title, description, imgUrl, link }) => {
  return (
    <Col size={12} sm={6} md={4}>
      <a
        href={link}
        role="button"
        target="_blank"
        style={{
          textDecoration: "none",
          outline: "none",
          color: "white",
        }}
      >
        <div className="proj-imgbx">
          <img src={imgUrl} alt="Project"/>
          <div className="proj-txtx">
            <h4>{title}</h4>
            <span>{description}</span>
          </div>
        </div>
      </a>
    </Col>
  );
};
